import { styled } from "@mui/material";

import { CatalystIcon as UnstyledCatalystIcon } from "@citrine/atoms/icons";

interface ContainerProps {
  align?: "center" | "top";
}

export const Container = styled("div", {
  shouldForwardProp: (prop) => prop !== "align",
})<ContainerProps>(({ align, theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(3),
  rowGap: theme.spacing(2),
  textAlign: "center",
  // Center vertically for the short greeting; top-align when the body carries a
  // tall list (the agent picker) so it scrolls instead of clipping its top.
  ...(align === "top" ? {} : { height: "100%", justifyContent: "center" }),
}));

export const CatalystIcon = styled(UnstyledCatalystIcon)(({ theme }) => ({
  fontSize: theme.spacing(8),
}));
